import axios from 'axios';


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {

        getByCategory(_, category_id) {
            return new Promise((resolve, reject) => {
                axios.get('/tahap-balaps/category/' + category_id).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        addTahapBalap(_, data) {
            return new Promise((resolve, reject) => {
                axios.post('/tahap-balaps', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        editTahapBalap(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/tahap-balaps/' + data.id, data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        addBatch(_, data) {
            return new Promise((resolve, reject) => {
                axios.post('/batches', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },
        

        editBatch(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/batches/' + data.id, data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        assignRegistran(_, data) {
            return new Promise((resolve, reject) => {
                axios.post('/batches/'+ data.batch_id +'/assign-registran', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        recordMotoResult(_, data) {
            return new Promise((resolve, reject) => {
                axios.post('/batches/'+ data.batch_id +'/record-moto-results', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        startBatch(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/batches/'+ data.id +'/start', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        processResult(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/batches/'+ data.id +'/process-results-and-qualify', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        submitRegistranBatch(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/batches/'+ data.id + '/process', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        sendWhatsapp(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/batches/'+ data.id + '/send-whatsapp', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        generateResult(_, data) {
            return new Promise((resolve, reject) => {
                axios.put('/batches/'+ data.id + '/generate-result', data).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        selectedAction(_, {action, data}) {
            return new Promise((resolve, reject) => {
                axios.post('/product-result/selected_action/' + action, { data: data }).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        exportReport(_, _params) {
            return new Promise((resolve, reject) => {
                axios.get('/product-result/selected_action/export_excel',  { params: _params, responseType: 'blob' }).then(resp => {
                    resolve(resp);
                }).catch(e => {
                    reject(e)
                })
            })
        },

        ReportByDate(_, _params) {
            return new Promise((resolve, reject) => {
                axios.get('/product-result/selected_action/export_pdf', { params: _params }).then(resp => {
                    resolve(resp);
                }).catch(e => {
                    reject(e)
                })
            })
        },

        deleteBatch(_, id) {
            return new Promise((resolve, reject) => {
                axios.delete('/batches/' + id).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        deleteTahapBalap(_, id) {
            return new Promise((resolve, reject) => {
                axios.delete('/tahap-balaps/' + id).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },

        deleteReport(_, id) {
            return new Promise((resolve, reject) => {
                axios.delete('/product-result/delete/' + id).then(resp => {
                    resolve(resp.data);
                }).catch(e => {
                    reject(e);
                })
            });
        },
    },
    getters: {

    }
}